<div *ngIf='!preview' class='pt-widget-treatment-data-interested-group'>
  <p class='title'>
    {{ title }}
  </p>
  <div class='body'>
    <div *ngIf='!loadingTree' class='tree-container'>
      <pt-tree
        (changeValue)="changeSelectedNode($event)"
        [nodes]="treeData"
      ></pt-tree>
    </div>
  </div>
</div>


<!--PREVIEW-->
<div *ngIf='preview' class='pt-widget-treatment-data-interested-group'>
  <p class='title'>
    {{ title }}
  </p>

  <form *ngIf='!loading'
        [formGroup]='formGroup'
        class='group-checkbox-form'>
    <div *ngFor='let check of checkboxPreview'
         class='form-check'>
      <label class='form-check-label d-flex align-items-baseline'>
        <ng-container>
          <pt-icon *ngIf='check.checked' [key]='IconCheck' class='text-success'></pt-icon>
          <pt-icon *ngIf='!check.checked' [key]='IconClose' class='text-danger'></pt-icon>
        </ng-container>
        {{ check.label }}
        <pt-w-help [help]='check?.help'></pt-w-help>
      </label>
    </div>
  </form>
</div>
